import { PlanningEventCategoryGeneratedEntity } from "./generated/PlanningEventCategoryGeneratedEntity";

export abstract class PlanningEventCategoryEntity extends PlanningEventCategoryGeneratedEntity {
    // Comment to preserve new line
}
